import { BottomSheet, CloseIcon, IconButton, Modal, Typography, useBreakpoint } from "@povio/ui";
import clsx from "clsx";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  icon?: React.ReactNode;
  title?: string;
  titleClassName?: string;
  children: React.ReactNode;
  modalClassName?: string;
  alwaysModal?: boolean;
  fitContent?: boolean;
};

export const ModalSheet = ({
  isOpen,
  onClose,
  icon,
  title,
  titleClassName,
  modalClassName,
  children,
  alwaysModal = false,
  fitContent,
}: Props) => {
  const aboveMobile = useBreakpoint("md");

  if (aboveMobile || alwaysModal) {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        aria-label="modal"
        modalClassName={modalClassName}
      >
        <div className="flex max-h-[calc(100dvh-96px)] w-full flex-col gap-6">
          <div className="flex w-full items-center justify-between">
            <div className="flex items-center gap-2">
              {icon}
              <Typography
                size="title-3"
                data-testid="introduction-user-name"
                className={titleClassName}
              >
                {title}
              </Typography>
            </div>
            <IconButton
              icon={CloseIcon}
              onPress={onClose}
              label="Close"
              size="none"
              color="secondary"
              variant="ghost"
              disableTooltip
            />
          </div>
          <div className="flex grow flex-col overflow-y-auto">{children}</div>
        </div>
      </Modal>
    );
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      onOpenChange={onClose}
      isDismissable
      aria-label="sheet"
      height={fitContent ? "auto" : "full"}
    >
      <div className={clsx("flex max-h-[calc(100dvh-96px)] flex-col gap-6 p-6", !fitContent && "grow")}>
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2">
            {icon}
            <Typography
              size="title-3"
              data-testid="introduction-user-name"
              className={titleClassName}
            >
              {title}
            </Typography>
          </div>
          <IconButton
            icon={CloseIcon}
            onPress={onClose}
            label="Close"
            size="none"
            color="secondary"
            variant="ghost"
            disableTooltip
          />
        </div>
        <div className="flex grow flex-col overflow-y-auto">{children}</div>
      </div>
    </BottomSheet>
  );
};
